export default "__VITE_ASSET__DF_9iDzY__"